<template>
  <div>
    <!-- word文档内容替换 -->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div v-if="this.globalVariable.tabs.length == 2">
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
        </div>
        <div v-else>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[2]
          }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div style="margin-top: 40px">
      <el-upload
        class="upload-demo"
         ref="upload"
        drag
        :action="uploadUrl"
        :data="param"
        :on-success="uploadSuccess"
        :on-preview="handlePreview"
        :limit="1"
        multiple
      >
      <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx类型文件,点击下面文件获取转换后的文件</div>
      </el-upload>
    </div>
    <div style="margin-top: 40px">
      <el-button type="primary" @click="templateExport()"
        >excel模板样例导出<i class="el-icon-download el-icon--right"></i
      ></el-button>
    </div>

  </div>
</template>
<script>
import {
  exportTemplateXlsx,
  baseUrl,
} from "@/api/api";
export default {
  data() {
    return {
      bodyLanguage: this.$store.state.globalLanguage,
      //目录
      //api方法名
      uploadUrl: baseUrl + "/openPlateform/api/uploadExcelFileToWord",
      downloadUrl: baseUrl + "/openPlateform/api/downloadApiDoc",
      downloadTemplateUrl: baseUrl + "/openPlateform/api/exportTemplateXlsx",
      param: {
        bodyLanguage: this.$store.state.globalLanguage,
      },
      fileList: [],
    };
  },
  created() {
    this.globalVariable.setTabs(["常用工具", "EXCEL转换标准WORD文档"]);
  },
  methods: {
    //目录初始化方法
    uploadSuccess(response, file, fileList) {
      console.log("uploadSuccess");
    },
    //点击文件列表中已上传文件进行下载
    handlePreview(file) {
      var a = document.createElement("a");
      var event = new MouseEvent("click");

      // 截取文件名中的文件类型并替换为 .docx
      var fileName = file.name;
      var index = fileName.lastIndexOf(".");
      if (index !== -1) {
        fileName = fileName.substring(0, index) + ".docx";
      }

      // 设置下载链接的文件名和URL
      a.download = fileName;
      a.href = this.downloadUrl + "?fileName=" + fileName + "&doclanguage=" + "zh_CN";
    
      // a.download = file.name;
      // a.href = this.downloadUrl + "?fileName=" + file.name;
      a.dispatchEvent(event);
      //释放创建的文件对象
      URL.revokeObjectURL(a.href);
    },
    templateExport() {
 
      try {
          var a = document.createElement("a");
          var event = new MouseEvent("click");
          //a.download = res;
          a.href = this.downloadTemplateUrl;
          a.dispatchEvent(event);
          //释放创建的文件对象
          URL.revokeObjectURL(a.href);
          this.$message("下载成功");
        } catch (error) {
          this.$message({
            showClose: true,
            message: "导出异常" + error,
            type: "error",
          });
        }
    },

  },
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>